import MuiTextField from "@mui/material/TextField";
import { Field, type FieldRenderProps } from "react-final-form";
import InputAdornment from "@mui/material/InputAdornment";

interface JsonFieldProps {
  name: string;
  step?: number;
  helperText?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  maxLength?: number;
  [key: string]: unknown;
}

export function JsonField(props: JsonFieldProps) {
  return (
    <Field
      {...props}
      name={props.name as string}
      format={(value: unknown) => {
        let result = value;
        try {
          if (!value) {
            result = "";
          } else if (typeof value === "object") {
            result = JSON.stringify(value, null, 2);
          }
        } catch {
          // Ignore JSON formatting errors
        }
        return typeof result === "string" ? result : String(result ?? "");
      }}
      parse={(value: string) => {
        let result: unknown = value;
        try {
          result = value ? JSON.parse(value) : "";
        } catch {
          // Ignore JSON parsing errors
        }
        return result;
      }}
      render={(fieldProps: FieldRenderProps<string, HTMLElement>) => {
        const { input, meta } = fieldProps;
        const { name, onChange, value, ...restInput } = input;
        const {
          step,
          helperText,
          startAdornment,
          endAdornment,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          maxLength,
          ...rest
        } = props;

        let error: boolean | null = null;
        let localHelperText = helperText;

        try {
          if (value) {
            JSON.parse(value);
          }
        } catch {
          localHelperText = "Invalid json";
          error = true;
        }

        return (
          <MuiTextField
            {...rest}
            name={name}
            helperText={
              ((meta as any).touched && (meta as any).submitError) ||
              localHelperText
            }
            error={
              ((meta as any).submitError && (meta as any).touched) || error
            }
            variant="outlined"
            inputProps={{
              step,
            }}
            InputProps={{
              ...restInput,
              autoComplete: "off",
              startAdornment: startAdornment && (
                <InputAdornment position="start">
                  {startAdornment}
                </InputAdornment>
              ),
              endAdornment: endAdornment && (
                <InputAdornment position="end">{endAdornment}</InputAdornment>
              ),
            }}
            onChange={onChange}
            value={value}
          />
        );
      }}
    />
  );
}
